/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItem_item$ref = any;
export type PdpRespSimilarItemsGridSeller_sellerItems$ref = any;
export type PdpRespSimilarItemsGridSeller_sellerItems = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
            readonly categoryPath: string | null;
            readonly categoryCode: string | null;
            readonly browseUrl: string | null;
            readonly title: string | null;
            readonly ecommerceTrackingParams: unknown | null;
            readonly " $fragmentRefs": PdpRespSimilarItem_item$ref;
        } | null;
    } | null> | null;
    readonly " $refType": PdpRespSimilarItemsGridSeller_sellerItems$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGridSeller_sellerItems",
  "type": "moreLikeThisConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "moreLikeThisEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryPath",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryCode",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "browseUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "ecommerceTrackingParams",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItem_item",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '9e3ce3882fe411562e2213c62fe3685a';
export default node;
